import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSnackBars } from '../../alerts/SnackBarProvider';
import { useRootStore } from '../../stores/BridgeProvider';
import { COLORS } from '../util/Colors';
import Spinner from '../util/Spinner';

const XeroCallback = () => {
  const { push } = useHistory();
  const { search } = useLocation();
  const { authStore } = useRootStore();
  const handleAlert = useSnackBars();

  useEffect(() => {
    const xeroCallbackPost = async () => {
      if (search.includes('error')) {
        push('/select-organization');
        handleAlert('Unable to connect to Xero organization', COLORS.orange);
        return;
      }
      try {
        await authStore.request.post(
          `${process.env.REACT_APP_API}/api/auth-xero`,
          { confirmationCode: search },
        );
        push('/link-organization');
      } catch (e) {
        console.error(e);
        push('/select-organization');
      }
    };
    xeroCallbackPost();
  }, []);
  return <Spinner />;
};

export default XeroCallback;
